import React from "react";
import axios from "axios";
import Player from "./Player";
import { detect } from "detect-browser";

const { isSupported } = require("twilio-video");
const browser = detect();

class VideoChat extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      identity: localStorage.getItem("user_type"),
      roomName: props.appointment.id,
      error_msg: "Browser not Compatible!!",
    };
  }
  componentDidMount() {
    localStorage.setItem("qualaroo_appointment_id", this.state.roomName);
  }
  render() {
    let render;
    let token = this.props.token;
    if ((isSupported || browser.name == "chromium-webview") && token) {
      render = (
        <Player
          endDateTime={this.props.endDateTime}
          isVideoCall={this.props.isVideoCall}
          roomName={this.state.roomName}
          token={token}
          displayNetworkText={this.props.displayNetworkText}
          endSession={this.props.endSession}
          isAudioCall={this.props.isAudioCall}
          appointment={this.props.appointment}
          history={this.props.history}
          handleOnHold={this.props.handleOnHold}
        />
      );
    } else if (!isSupported) {
      render = (
        <div className="preload">
          <div className="preload-text">{this.state.error_msg}</div>
        </div>
      );
    } else {
      render = (
        <div className="preload">
          <div className="preload-text">Loading... Please Wait!!</div>
        </div>
      );
    }
    return render;
  }
}

export default VideoChat;
